import { Tag } from '@lifebit-ai/lds'
import styled from 'styled-components'

/**
 * One label chip for every surface that shows labels — request tables and the request rail alike
 * — so a label is the same size wherever it appears.
 */
export const LabelTag = styled(Tag)`
  && {
    padding: ${({ theme }) => `${theme.size.space['01'] as string} ${theme.size.space['02'] as string}`};
  }
`
